module.exports = __webpack_public_path__ + "static/media/SIDRA SALAMEH.dc5c86dd.png";